// Файл access_realtime_sync.js

/**
 * Модуль содержит логику доступов для запросов к серверу.
 * Компонент `CHANNEL_NAME` формирует связанную часть пользовательского
 * интерфейса.
 * Компонент `LOCK_NAME` формирует связанную часть пользовательского
 * интерфейса.
 * Файл объединяет вспомогательные операции запросов к серверу.
 */

const CHANNEL_NAME = 'potale:access:sync:v1';
const LOCK_NAME = 'potale:access:refresh:v1';



const log_refresh_error = (error) => {
    const status = Number(error?.response?.status || 0);

    if (status !== 401) {
        console.error('Ошибка обновления прав:', error);
    }
};

const create_channel = () => {
    if (typeof BroadcastChannel !== 'function') {
        return null;
    }

    try {
        return new BroadcastChannel(CHANNEL_NAME);

    } catch (error) {
        return null;
    }
};

const subscribe_access_realtime = ({
    apply_access_rights,
    refresh_access,
}) => {
    let active = true;
    let refresh_running = false;
    let requested_revision = 0;
    const channel = create_channel();

    const refresh_and_share = async () => {
        try {
            const rights = await refresh_access();

            if (active && channel) {
                channel.postMessage({
                    type: 'access_snapshot',
                    rights,
                });
            }

        } catch (error) {
            if (active) {
                log_refresh_error(error);
            }
        }
    };

    const run_refresh_queue = async () => {
        if (refresh_running) {
            return;
        }

        refresh_running = true;
        let handled_revision = 0;

        try {
            while (
                active
                && handled_revision < requested_revision
            ) {
                const target_revision = requested_revision;
                await refresh_and_share();
                handled_revision = target_revision;
            }

        } finally {
            refresh_running = false;
        }
    };

    const refresh_current_access = () => {
        requested_revision += 1;

        if (refresh_running) {
            return;
        }

        const locks = window.navigator?.locks;

        if (!channel || typeof locks?.request !== 'function') {
            run_refresh_queue();
            return;
        }

        locks.request(
            LOCK_NAME,
            { ifAvailable: true },
            async (lock) => {
                if (active && lock) {
                    await run_refresh_queue();
                }
            },
        ).catch((error) => {
            if (active) {
                log_refresh_error(error);
            }
        });
    };

    const apply_remote_snapshot = (event) => {
        const message = event?.data;

        if (
            active
            && message?.type === 'access_snapshot'
            && Array.isArray(message.rights)
        ) {
            apply_access_rights(message.rights);
        }
    };

    if (channel) {
        channel.onmessage = apply_remote_snapshot;
    }
    window.addEventListener(
        'potale:access-updated',
        refresh_current_access,
    );

    return () => {
        active = false;
        window.removeEventListener(
            'potale:access-updated',
            refresh_current_access,
        );

        if (channel) {
            channel.close();
        }
    };
};


export {
    subscribe_access_realtime,
};
